<!-- eslint-disable vue/no-v-html -->
<template>
  <b-input-group>
    <b-form-datepicker
      ref="datepicker"
      v-model="internalValue"
      v-bind="{...$props, ...labels}"
      right
      :button-only="buttonOnly"
      :date-format-options="dateFormatOptions"
      :locale="locale || $i18n.locale"
      @input="handleInput"
    />
    <b-input-group-append
      v-if="isDateCancellable"
      class="d-flex align-items-center datepicker"
      @click="handleReset()"
    >
      <i class="icon fa-fw fal fa-circle-x" />
    </b-input-group-append>
    <b-alert
      v-if="plannedDateAlert && isDateValueCancelled"
      variant="warning"
      class="reset-date-alert"
      :show="true"
      v-html="plannedDateAlert"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    plannedDateAlert: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    canReset: {
      type: Boolean,
      default: true,
    },
    locale: {
      type: String,
      default: ''
    },
    buttonOnly: {
      type: Boolean,
      default: false,
    },
    dateFormatOptions: {
      type: Object,
      default: () => ({ year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' })
    }
  },
  data() {
    return {
      internalValue: this.value,
      cancelled: !this.value
    }
  },
  computed: {
    labels () {
      return {
        labelPrevDecade: this.$t('datePicker.labelPrevDecade'),
        labelPrevYear: this.$t('datePicker.labelPrevYear'),
        labelPrevMonth: this.$t('datePicker.labelPrevMonth'),
        labelCurrentMonth: this.$t('datePicker.labelCurrentMonth'),
        labelNextMonth: this.$t('datePicker.labelNextMonth'),
        labelNextYear: this.$t('datePicker.labelNextYear'),
        labelNextDecade: this.$t('datePicker.labelNextDecade'),
        labelToday: this.$t('datePicker.labelToday'),
        labelSelected: this.$t('datePicker.labelSelected'),
        labelNoDateSelected: this.$t('datePicker.labelNoDateSelected'),
        labelCalendar: this.$t('datePicker.labelCalendar'),
        labelNav: this.$t('datePicker.labelNav'),
        labelHelp: this.$t('datePicker.labelHelp'),
      }
    },
    isDateValueCancelled() {
      return this.cancelled
    },
    isDateCancellable() {
      return this.canReset && !!this.internalValue && !this.cancelled && !this.disabled
    },
  },
  methods: {
    handleInput(value) {
      this.cancelled = false
      !this.disabled && this.$emit('input', value)
    },
    handleReset() {
      this.cancelled = true
      this.internalValue = null
      this.$emit('input', null)
    },
  },
}
</script>

<style scoped lang="scss">
  .datepicker {
    position: absolute;
    right: 1em;
    top: 0.8em;
    cursor: pointer;
  }
  .reset-date-alert {
    margin: 0.5em 0 0;
    position: relative;
    top: 100%;
    width: 100%;
  }
  </style>
